import LegalPageLayout from '@/components/feature/LegalPageLayout';

export default function PrivacyPage() {
  return (
    <LegalPageLayout title="Gizlilik Politikası">
      <p>Atak Sistem Enerji olarak, web sitemizi ziyaret eden kullanıcılarımızın gizliliğine büyük önem veriyoruz. Bu Gizlilik Politikası, kişisel verilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu açıklamaktadır.</p>

      <h4>1. Toplanan Bilgiler</h4>
      <p>Web sitemiz üzerinden iletişim formu aracılığıyla ad, soyad, telefon numarası, e-posta adresi, il/ilçe bilgisi, ısıtılacak alan bilgisi ve mesaj içeriğiniz toplanmaktadır. Bu bilgiler yalnızca sizin talebiniz doğrultusunda tarafınıza geri dönüş yapabilmek amacıyla toplanır.</p>

      <h4>2. Bilgilerin Kullanımı</h4>
      <p>Toplanan kişisel verileriniz aşağıdaki amaçlarla kullanılmaktadır:</p>
      <ul>
        <li>Hizmet talebinize yanıt verebilmek</li>
        <li>Size uygun sistem hakkında bilgi ve teklif sunmak</li>
        <li>Müşteri hizmetleri süreçlerini yürütmek</li>
      </ul>

      <h4>3. Bilgi Güvenliği</h4>
      <p>Kişisel verilerinizin güvenliğini sağlamak için uygun teknik ve idari güvenlik önlemleri alınmaktadır. Verileriniz yetkisiz erişime, kayba veya kötüye kullanıma karşı korunmaktadır.</p>

      <h4>4. Çerezler</h4>
      <p>Web sitemiz, kullanıcı deneyimini iyileştirmek amacıyla çerezler kullanabilir. Çerez kullanımı hakkında detaylı bilgi için Çerez Politikamızı inceleyebilirsiniz.</p>

      <h4>5. Üçüncü Taraflarla Paylaşım</h4>
      <p>Kişisel verileriniz, yasal zorunluluklar haricinde hiçbir üçüncü taraf ile paylaşılmaz.</p>

      <h4>6. Değişiklikler</h4>
      <p>Bu gizlilik politikası gerektiğinde güncellenebilir. Güncellemeler web sitemizde yayınlanacaktır.</p>

      <h4>7. İletişim</h4>
      <p>Gizlilik politikamız hakkında sorularınız için WhatsApp veya telefon üzerinden bizimle iletişime geçebilirsiniz.</p>
    </LegalPageLayout>
  );
}